<mat-table [dataSource]="dataSource" id="exported-reports-summary-table">
  <ng-container *ngFor="let col of columns" matColumnDef="{{col.columnDef}}" id="{{col.id}}">
    <mat-header-cell *matHeaderCellDef>
      {{col.headerText}}
      <mat-icon *ngIf="col.hoverMessage" [matTooltip]="col.hoverMessage" [matTooltipClass]="'custom-tooltip'"
                id="{{col.id}}-info" class="info">info
      </mat-icon>
    </mat-header-cell>
    <mat-cell *matCellDef="let row" class="{{col.columnDef}}-cell"
              (click)="col.columnDef==='delete' && delete(row.reportId)">
      <a *ngIf="row.reportStatus === BatchExportStatus.COMPLETED && col.columnDef === 'reportName'" class="report-link"
         [matTooltip]="col.tableText(row)"
         [matTooltipDisabled]="col.columnDef !== 'reportName' || col.tableText(row).length < 15"
         (click)="openFile(row)">{{col.tableText(row)}}</a>
      <span class="cell-text"
            [matTooltip]="col.tableText(row)"
            [matTooltipDisabled]="col.columnDef !== 'reportName' || col.tableText(row).length < 15"
            *ngIf="col.columnDef !== 'reportName' || row.reportStatus !== BatchExportStatus.COMPLETED">{{col.tableText(row)}}</span>
      <mat-icon *ngIf=col.icon class="{{col.icon}}">{{col.icon}}</mat-icon>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="stringColumnsForRowDef"></mat-header-row>
  <mat-row *matRowDef="let row; columns: stringColumnsForRowDef;"></mat-row>
</mat-table>
